import { WaIcon } from "@/components/landing/WaIcon";
import { waLink } from "@/lib/site";

export const btnPrimary =
  "inline-flex min-h-[56px] items-center justify-center gap-2.5 rounded-xl bg-[#1FA89A] px-7 text-[18px] font-bold text-[#052438] transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#25BBAC] focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-[#0B3C5D]";

export const btnSecondary =
  "inline-flex min-h-[56px] items-center justify-center rounded-xl border-2 border-[#0B3C5D] px-7 text-[18px] font-bold text-[#0B3C5D] transition-colors duration-200 hover:bg-[#0B3C5D] hover:text-white focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-[#1FA89A]";

export const WaButton = ({ text, label = "Quiero asesorarme", testId, className = "" }) => (
  <a href={waLink(text)} target="_blank" rel="noopener noreferrer" data-testid={testId} className={`${btnPrimary} ${className}`}>
    <WaIcon className="h-6 w-6" /> {label}
  </a>
);

export const SectionTitle = ({ eyebrow, title, intro, center = false }) => (
  <div className={`mb-10 max-w-2xl sm:mb-14 ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && <p className="mb-3 text-[15px] font-bold uppercase tracking-[0.12em] text-[#13766C]">{eyebrow}</p>}
    <h2 className="text-[30px] font-extrabold leading-[1.15] tracking-tight text-[#0B3C5D] sm:text-4xl lg:text-[44px]">{title}</h2>
    {intro && <p className="mt-4 text-[18px] leading-relaxed text-[#4A5864]">{intro}</p>}
  </div>
);
